import Game1 from './../assets/images/blogs/game.png';
import Game2 from './../assets/images/blogs/game1.jpg';
import Crypto from './../assets/images/blogs/crypto.jpg';
import Compe from './../assets/images/blogs/compe.jpg';
import Number from './../assets/images/blogs/number.png';
import Deepl from './../assets/images/blogs/deepl.jpg';
import Quantu from './../assets/images/blogs/quantu.jpg';
import OSDev from './../assets/images/blogs/osdev.jpg';

export const blogList = [
    {
        title: 'Intro to Game Development',
        date: '2018-07-21',
        text: 'An overview of how game development works and varius roles involved. ',
        author: 'Sachin Jain',
        image: Game1,
        link: 'https://medium.com/@deepanshnagaria/intro-to-game-development-205193f5c66f'
    },
    {
        title: 'Getting started with Game Dev',
        date: '2018-07-21',
        text: 'Making your first video game is a fun experience in its own. The hope of making it all work and playing yourself one day along with the regular.',
        author: 'Sachin Jain',
        image: Game2,
        link: 'https://medium.com/@deepanshnagaria/getting-started-with-game-dev-2e1f32b9105b'
    },
    {
        title: 'Introduction to Cryotography',
        date: '2018-07-23',
        text: 'From the ancient times, the transfer of the information from one place to another securely was the great challenge. Cryptography is not a new term. The concepts of cryptography had also been...',
        author: 'Prateek Roushan',
        image: Crypto,
        link: 'https://medium.com/@acmiitr/introduction-to-cryptography-ac274100369d'
    },
    {
        title: 'Intro to Competitive Programming',
        date: '2018-07-21',
        text: 'Many of you might have heard about the term Competitive Programming and would have wondered what it actually means. I am writing this blog to provide a brief intro to it as well as tell you about the requirements to start pursuing it.',
        author: 'Vinay Aggarwal',
        image: Compe,
        link: 'https://medium.com/@acmiitr/intro-to-competitive-programming-be194f1c8cb2',
    },
    {
        title: 'Basic Number Theory',
        date: '2018-06-23',
        text: 'A lecture(sorta) on basic number theory and lets you know how to proeced forward.',
        author: 'Vinay Aggarwal',
        image: Number,
        link: 'https://medium.com/@acmiitr/basic-number-theory-6b5e0d0099e0'
    },
    {
        title: 'Guide to Deep Learning',
        link: 'https://medium.com/@vlgiitr18/guide-to-deep-learning-585bfcad0b43',
        text: 'A guide to get started with Deep Learning as well as an in-depth knowledge of the field.',
        author: 'VLG IIT Roorkee',
        image: Deepl,
        date: '2019-05-17'
    },
    {
        title: 'Guide to Quantum Computing',
        link: 'https://medium.com/@acmiitr/guide-to-quantum-computing-d9249d400e2',
        text: 'A blog to give the reader a headstart into the field of quantum computing, oulining the prerequisites, basics, advanced topics and implementations.',
        author: 'Rhea Parekh, Daattavya Aggarwal, Natansh Mathur and Sudhang Varshney',
        image: Quantu,
        date: '2020-02-19'
    },
    {
        title: 'OS development guide',
        link: 'https://kssuraaj28.github.io/',
        text: 'Series of blogs discussing the journey to creation of your own Operating system',
        author: 'Suraaj K S',
        image: OSDev,
    }
]